module.exports = __webpack_public_path__ + "media/img/pages/companies/manor-27bde2d22cad3c062ae7a4f04ab6a814.png";